import * as React from 'react';

function SvgHelp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 14.97 23.94" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M12.76 1.64A9.06 9.06 0 007.22 0a7.58 7.58 0 00-4.28 1.15Q.18 3 0 7.29h4.27A4.65 4.65 0 015 4.86a2.61 2.61 0 012.4-1.17 2.73 2.73 0 012.4.95 3.65 3.65 0 01.65 2.1 3.2 3.2 0 01-.72 1.84 3.6 3.6 0 01-.85.9 19.56 19.56 0 00-3.33 2.76C5 13 4.91 14 4.86 15.55c0 .1 0 .33.4.33h3.32a.36.36 0 00.4-.36 4.79 4.79 0 01.18-1.17 3.6 3.6 0 011.27-1.59l1.17-.84a13.05 13.05 0 002.28-2.09A5.67 5.67 0 0015 6.5a5.67 5.67 0 00-2.24-4.86zM7.15 18.52a2.59 2.59 0 00-2.73 2.64A2.59 2.59 0 007 23.93a2.56 2.56 0 002.76-2.61 2.6 2.6 0 00-2.61-2.8z" />
    </svg>
  );
}

const MemoSvgHelp = React.memo(SvgHelp);
export default MemoSvgHelp;
